// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBar_wrapper__G8Pbn","logo":"NavBar_logo__UGyzu","logo_up":"NavBar_logo_up__Fxizv","logo_down":"NavBar_logo_down__BZ72Y","team_name":"NavBar_team_name__46H83"};